import { customerAlias } from './customerAlias';
import { numFormat } from './numFormat';

export function invoiceDescription(invoiceDetail: any): string {
  return `Invoice #: <b>${invoiceDetail._id}</b> / ${customerAlias(invoiceDetail.customer, false)} / Invoice Value: <b>${numFormat(invoiceDetail.total)} SAR</b>`;
}

export function miscInvoiceDescription(miscInvDetail: any, miscCustomer: any): string {
  return `Invoice #: <b>${miscInvDetail._id}</b> / ${customerAlias(miscCustomer, false)} / Invoice Value: <b>${numFormat(miscInvDetail.total)} SAR</b>`;
}
